module.exports = __webpack_public_path__ + "img/img-process1@2x.2d3ac534.jpg";